/*
Changelog
---------
Amv6  - Add Delete GIN/GRN button
Amv09 - Add GRN interface
Amv12 - Add upload GR template for EDI on Administer section.
*/

import { HttpClient, HttpEventType, HttpRequest } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { CartDrawerManagerService } from 'src/app/cart-drawer/cart-drawer-manager.service';
import { OverlayManagerService } from 'src/app/overlay-manager.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
//Amv12
import * as fs from 'file-saver';
import { Row, Workbook, Worksheet } from 'exceljs';
//Amv12 end


@Component({
  selector: 'app-tab-customer-booking',
  templateUrl: './tab-customer-booking.component.html',
  styleUrls: ['./tab-customer-booking.component.scss']
})
export class TabCustomerBookingComponent implements OnInit {

  ROUTE_ADMIN_BOOKINGS = environment.api_location + "/bookings/list";
  ROUTE_ADMIN_BOOKING_DELETE = environment.api_location_admin + "/booking/delete";
  ROUTE_ADMIN_BOOKING_PROFILE = environment.api_location_admin + "/booking/profile/";
  ROUTE_ADMIN_PROCESS_BOOKING = environment.api_location+"/booking/process-booking";

  ROUTE_ADMIN_CREATE_GRN = environment.api_location_admin+"/booking/create-grn";
  ROUTE_ADMIN_CREATE_GIN = environment.api_location_admin+"/booking/create-gin";
  //Amv6
  ROUTE_ADMIN_DELETE_GIN1 = environment.api_location_admin+"/booking/delete";

  //Amv09
  ROUTE_ADMIN_LOAD_GRN = environment.api_location_admin+"/booking/load-grn/";
  ROUTE_ADMIN_UPDATE_GRN = environment.api_location_admin+"/booking/update-grn/";
  //Amv09

  //ROUTE_ADMIN_LOAD_GRN = environment.api_location_admin+"/booking/load-grn/";
  ROUTE_ADMIN_LOAD_GIN = environment.api_location_admin+"/booking/load-gin/";

  ROUTE_ADMIN_UPDATE_GIN = environment.api_location_admin+"/booking/update-gin/";
  ROUTE_ADMIN_CLOSE_BOOKING = environment.api_location_admin+"/booking/close-booking";

  //Amv08
  ROUTE_CHECK_EDI = environment.api_location + "/edi/GI/isEDI";
  ROUTE_EDI_CLOSE = environment.api_location + "/edi/closeBooking";
  ROUTE_EDI_SUBMIT_POD = environment.api_location + "/edi/submitPOD";
  //Amv08 end

  ROUTE_FILE_UPLOAD = environment.api_location + "/booking/upload-file";
  ROUTE_FILE_DELETE = environment.api_location + "/booking/delete-file";
  ROUTE_FILE_DOWNLOAD = environment.api_location + "/booking/file/";

  ROUTE_DO_NAME = environment.api_location + "/booking/create-DO-name";
  ROUTE_DO_GENERATE = environment.api_location + "/booking/get-DO";

  //Amv12
  ROUTE_EDI_GR_Template = environment.api_location + "/edi/GR/download-template";
  ROUTE_EDI_GR_UPLOAD = environment.api_location + "/edi/GR/upload-template";
  ROUTE_CHECK_GR_EDI = environment.api_location + "/edi/GR/isEDI";
  //Amv12 end

  bookings;
  warehouses;

  isLoading = true;
  loadingBooking = true;

  selectedBooking;
  loadedBooking;

  deletingBooking = false;

  BOOKING_SUMMARY = 0;
  BOOKING_DETAILS = 1;
  BOOKING_DOCUMENTS = 2;
  BOOKING_ADMIN = 3;
  currentTab = this.BOOKING_DETAILS;

  bookingFilterTerm;
  BOOKING_FILTER_TYPE_ALL = 'ALL';
  BOOKING_FILTER_TYPE_INBOUND = 'GRN';
  BOOKING_FILTER_TYPE_OUTBOUND = 'GIN';
  BOOKING_FILTER_TYPE_TRUCKING = 'TRUCKING';
  BOOKING_FILTER_TYPE_AIR = 'AIR';
  BOOKING_FILTER_TYPE_SEA = 'SEA';

  COMPLETION_FILTER_TYPE_PENDING = 0;
  COMPLETION_FILTER_TYPE_ONGOING = 1;
  COMPLETION_FILTER_TYPE_COMPLETED = 2;

  bookingFilterType = this.BOOKING_FILTER_TYPE_ALL;
  completionFilter = this.BOOKING_FILTER_TYPE_ALL;

  filesToUpload = [];
  fileUploadProcessQueue;
  navigationSubscription;

  GRN_Task;
  GIN_Task;
  Truck_Task;

  //Amv6
  triggerBookingDelete = false;

  //Amv07
  podsignatory;
  isEnter = true;

  //Amv08
  triggerCloseBooking = false;

  //Amv12
  isEdi = false;
  isGRProcessed = false;
  isPassed = true;
  isUpload = false;
  uploading = false;
  fileItemsToLoad = 0;
  processGRItems: EDIGRItems[] = [];

  message = "";
  total_items = 0;
  updated_items = 0;
  not_found_items = 0;
  not_found_sn = [];
  failed_items = 0;
  errors = [];
  //Amv12 end

  constructor (private authSvc: AuthService, private http: HttpClient, private overlayManager: OverlayManagerService, private cartManager: CartDrawerManagerService,
    private staticData: StaticDataService, private fileDownloadService: FileDownloadService, private router: Router) { }

  ngOnInit(): void {

    this.init();
    // Subscribe to router reload
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if(e instanceof NavigationEnd) {
        this.init();
      }
    });
  }

  init() {
    this.getBookings();
    this.http.get(environment.api_location_admin + "/resource/warehouses").subscribe(data => {
      this.warehouses = data;
    });
  }

  isAdmin() {
    return this.authSvc.user() && this.authSvc.user.role == 0;
  }

  openBookingDialog() {
    this.overlayManager.showBookingPanel(0);
  }

  getBookings() {

    let resolver = null;
    const promise = new Promise(resolve => resolver = resolve);

    this.http.get(this.ROUTE_ADMIN_BOOKINGS).subscribe(response => {
      
      this.bookings = response;
      for(const booking of this.bookings) {
        if(booking.Closed_DateTime) {
          booking.status = this.COMPLETION_FILTER_TYPE_COMPLETED;
        } else if(booking.Processed_DateTime) {
          booking.status = this.COMPLETION_FILTER_TYPE_ONGOING;
        } else {
          booking.status = this.COMPLETION_FILTER_TYPE_PENDING;
        }

        booking.filterSymantics = "REF_NO:"+booking.Ref_No+"|GIN_PERMIT:"+booking.GIN_Permit+"|GRN_PERMIT:"+booking.GRN_Permit;
        booking.filterSymantics = booking.filterSymantics.toUpperCase();
      }
      
      if(this.bookings.length > 0) {
        this.selectBooking(this.bookings[0]);
      }

      //Amv6
      this.triggerBookingDelete = false;
      //Amv6 -end

      //Amv08 - for close booking
      this.triggerCloseBooking = false;

      this.isLoading = false;
      resolver("Bookings Updated");
    });

    return promise;
  }

  selectBooking(booking) {
    this.selectedBooking = booking;
    //Amv12
    this.isEdi = false;
    if(this.selectedBooking['Ref_No']){
      const booking_ref_no = this.selectedBooking['Ref_No'];

      const hasEDI = booking_ref_no.includes("-EDI");

      this.isEdi = hasEDI;
    }

    this.processGRItems = [];
    this.isGRProcessed = false;
    this.uploading = false;
    this.isPassed = true;
    this.isUpload = false;
    //Amv12 end
    this.loadingBooking = true;
    //Amv07
    this.podsignatory = "";

    //Amv08
    this.triggerBookingDelete = false;
    this.triggerCloseBooking = false;
    //Amv08 end

    this.currentTab = this.BOOKING_DETAILS;
    const targetURL = this.ROUTE_ADMIN_BOOKING_PROFILE + booking.ID;
    const promise = this.http.get(targetURL);
    
    promise.subscribe(response => {
      this.selectedBooking = response;
      (response as any).Documents.forEach(doc => {
        (doc as any).showDeleteFileView = false;
      });
      this.loadedBooking = response;
      this.loadingBooking = false;
    });

    return promise;
  }

  addToCart(item) {
    this.cartManager.addToCart(item, 1);
  }

  isInCart(item) {
    return this.cartManager.inCart(item);
  }

  showItemDetails(item) {
    this.overlayManager.showBookingItemRecord(item);
  }

  selectTab(tab) {
    if(tab != this.currentTab) {
      this.currentTab = tab;
    }

    if(this.currentTab == this.BOOKING_ADMIN) {
      this.reloadBookingTasks();
    }
  }

  reloadBookingTasks() {
    this.GRN_Task = null;
    this.GIN_Task = null;
    // this.http.get(this.ROUTE_ADMIN_LOAD_GIN+this.selectedBooking.ID).subscribe((response) => {
    //   this.GIN_Task = response;
    // });

    //Amv09
    if(this.selectedBooking.Booking_Type === "GIN"){
      // console.log("GIN");
      this.http.get(this.ROUTE_ADMIN_LOAD_GIN+this.selectedBooking.ID).subscribe((response) => {
        this.GIN_Task = response;
        // console.log(this.GIN_Task);
      });
    }else{
      // console.log("GRN");
      this.http.get(this.ROUTE_ADMIN_LOAD_GRN+this.selectedBooking.ID).subscribe((response) => {
        this.GRN_Task = response;
        // console.log(this.GRN_Task);
      });
    }
    //Amv09 - end
  }

  addFile(newFiles: FileList) {

    if(!this.filesToUpload) {
      this.filesToUpload = [];
    }

    //if there's no file, we just take the file list and convert it into an array
    for(let i = 0; i < newFiles.length; i++) {
      const file = newFiles[i];

      let exists = false;

      //Reject if not in pre declared extensions
      if(!this.staticData.isFileTypeAllowed(file)) {
        continue;
      }

      for(let j = 0; j < this.filesToUpload.length; j++) {
        const oldFile = this.filesToUpload[j];

        if((oldFile.name == file.name) && (oldFile.type == file.type) && (oldFile.size == file.size) && (oldFile.lastModified == file.lastModified)) {
          exists = true;
        }
      }

      if(!exists) {
        this.filesToUpload.push(file);
      }
    }
  }

  removeFile(file) {
    this.filesToUpload.splice(this.filesToUpload.indexOf(file), 1);
  }

  getType(fileName) {

    const extension = this.staticData.getExtension(fileName);

    if(extension == "doc" || extension == "docx") {
      return "fas fa-file-word text-primary";
    }

    if(extension == "ppt" || extension == "pptx") {
      return "fas fa-file-powerpoint text-danger";
    }

    if(extension == "xls" || extension == "xlsx") {
      return "fas fa-file-excel text-success";
    }

    if(extension == "pdf") {
      return "fas fa-file-pdf text-danger";
    }

    if(extension == "jpg" || extension == "jpeg" || extension == "png" || extension == "jpe" || extension == "tif" || extension == "tiff" || extension == "gif") {
      return "fas fa-image text-info";
    }

    return "fas fa-file-alt";
  }

  getSize(bytes) {

    if(bytes === 0) return '0 Bytes';
    const k = 1024;
    const decimals = 2;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  uploadFiles() {

    console.log("Start Upload Files");

    if(this.filesToUpload && this.filesToUpload.length > 0) {
      this.fileUploadProcessQueue = [];

      for(const selectedFile of this.filesToUpload) {
        const fileProcessItem = {
          file: selectedFile,
          uploadComplete: false,
          error: false,
          progress: 0
        };

        this.fileUploadProcessQueue.push(fileProcessItem);
      }
      const fileUploadBehaviorSubjects = [];
      for(const fileQueueItem of this.fileUploadProcessQueue) {
        const uploadForm = new FormData();
        uploadForm.append("Booking_ID", this.selectedBooking.ID);
        uploadForm.append("Uploaded_File", fileQueueItem.file);

        const request = new HttpRequest('POST', this.ROUTE_FILE_UPLOAD, uploadForm, {
          reportProgress: true,
          responseType: 'json'
        });

        const behaviorSubject = this.http.request(request);

        behaviorSubject.subscribe(
          response => {
            let data = response as any;

            fileQueueItem.uploadComplete = true;

            if(data.type === HttpEventType.Response) {
              fileQueueItem.uploadComplete = true;
              // this.selectBooking(this.selectedBooking);

              // this.currentTab = this.BOOKING_DETAILS;
              //Amv08
              this.currentTab = this.BOOKING_DOCUMENTS;

              this.filesToUpload = [];

              //Amv08
              const payload ={
                bookingID: null,
                bookingType: null,
                fileName: null,
                fileType: null
              };

              payload.bookingID = this.selectedBooking.ID;
              payload.bookingType = this.selectedBooking.Booking_Type;
              payload.fileName = fileQueueItem.file.name;
              payload.fileType = fileQueueItem.file.type;

              let fileData = fileQueueItem.file.name;

              console.log(payload);

              //Only DO will trigger EDI sent out
              if(fileData!= null && fileData.includes('_DO')){
                this.http.post(this.ROUTE_EDI_SUBMIT_POD, payload).subscribe((response)=>{
                  console.log(response);
                  let ediData = response;

                  if(ediData['edi'] == true &&  ediData['ediReturn'] == 200){
                    //success sent EDI to client
                    
                    //Pop up will be prompt
                    this.triggerPopup2(fileData + " has been sent via EDI." , 0, fileData);

                  }else if (ediData['edi'] == true &&  ediData['ediReturn'] != 200){
                    this.triggerPopup2(fileData + " failed to sent via EDI." , 1, fileData);
                  }

                });
              }

              //Amv08 end
              this.selectBooking(this.selectedBooking);

            }

            if(data.type === HttpEventType.UploadProgress) {
              fileQueueItem.progress = Math.round(100 * data.loaded / data.total);
            }
          },
          error => {
            fileQueueItem.uploadComplete = false;
            fileQueueItem.error = true;
          }
        );

        fileUploadBehaviorSubjects.push(behaviorSubject);
      }
    }
  }

  downloadFile(file) {
    const url = this.ROUTE_FILE_DOWNLOAD + file.ID;
    this.fileDownloadService.downloadFile(url, file.Original_File_Name);
  }

  openDeleteFile(doc) {
    doc.showDeleteFileView = true;
  }

  undoDelete(doc) {
    doc.showDeleteFileView = false;
  }

  deleteFile(file) {
    const payload = { File_ID: file.ID };
    this.http.post(this.ROUTE_FILE_DELETE, payload).subscribe(() => {
      this.selectBooking(this.selectedBooking);
      this.currentTab = this.BOOKING_DOCUMENTS;
    });
  }

  updateBookingFilterType() {
    this.getBookings().then(response => {

      let filteredList = this.bookings;

      if(this.bookingFilterType == this.BOOKING_FILTER_TYPE_ALL) {
        //Ignore
      } else {
        filteredList = filteredList.filter(booking => {
          return booking.Booking_Type == this.bookingFilterType;
        });
      }

      if(this.completionFilter == this.BOOKING_FILTER_TYPE_ALL) {
        //Ignore
      } else {
        filteredList = filteredList.filter(booking => {
          return booking.status == this.completionFilter;
        });
      }

      this.bookings = filteredList;
    });
  }
  
  isProcessed() {
    return this.selectedBooking.Processed_DateTime !== null;
  }

  isClosed() {
    return this.selectedBooking.Closed_DateTime !== null;
  }

  processBooking() {

    const payload = {
      Booking_ID:null
    };
    payload.Booking_ID = this.selectedBooking.ID

    this.http.post(this.ROUTE_ADMIN_PROCESS_BOOKING, payload).subscribe((response) => {
      this.selectBooking(this.selectedBooking).subscribe((response2)=> {

        let promise;

        switch(this.selectedBooking.Booking_Type) {
          case this.BOOKING_FILTER_TYPE_INBOUND: 
            promise = this.http.post(this.ROUTE_ADMIN_CREATE_GRN, payload);
            break;
          case this.BOOKING_FILTER_TYPE_OUTBOUND:
            promise = this.http.post(this.ROUTE_ADMIN_CREATE_GIN, payload);
            break;
        }
        
        promise.subscribe((response) => {
          //Amv08 - change to refresh the whole page
          // this.selectTab(this.BOOKING_ADMIN);
          window.location.reload();
        });
      })
    });

  }

  updateGIN(task) { 
    this.triggerBookingDelete = true;

    this.http.post(this.ROUTE_ADMIN_UPDATE_GIN, task).subscribe(() => {
      // this.reloadBookingTasks();

      //Amv08
      console.log(task);
      this.http.post(this.ROUTE_CHECK_EDI, task, { observe: 'response' }).subscribe((response)=>{
        console.log(response);
        let ediResult = response.body;

        if(ediResult['edi'] == true){
          if(ediResult['ediData'] == 200){
            //EDI successfully sent
            this.triggerBookingDelete = false;
            this.reloadBookingTasks();
          }else{
            // 500, failed to send EDI, or EDI sent with different status
            console.log(ediResult['ediData']);
          }
        }else{
          //No EDI data
          this.triggerBookingDelete = false;
          this.reloadBookingTasks();
        }

      },
      error =>{
        //If no completion date or any error 
        this.triggerBookingDelete = false;
        this.reloadBookingTasks();
      });
      
      // this.reloadBookingTasks();
      //Amv08 end

    });
  }

  //Amv09
  updateGRN(task) {
    this.triggerBookingDelete = true;

    //Amv12
    this.http.post(this.ROUTE_ADMIN_UPDATE_GRN, task, { observe: 'response' }).subscribe((response)=>{
      
      this.http.post(this.ROUTE_CHECK_GR_EDI, task, { observe: 'response' }).subscribe((response)=>{
        console.log(response);
        let ediGRResult = response.body;

        if(ediGRResult['edi'] == true){
          if(ediGRResult['ediData'] == 200){
            //EDI send out and updated in NCC
            this.triggerBookingDelete = false;
            this.reloadBookingTasks();
          }else{
            console.log(ediGRResult['ediData']);
          }

        }else{
          //Booking not EDI
          console.log("GR not EDI");
          this.triggerBookingDelete = false;
          this.reloadBookingTasks();
        }

      });
      // this.triggerBookingDelete = false;
      // this.reloadBookingTasks();
    },
    error => {
      this.triggerBookingDelete = false;
      this.reloadBookingTasks(); 
    });
    // Amv12 end

    // this.http.post(this.ROUTE_ADMIN_UPDATE_GRN, task, { observe: 'response' }).subscribe((response)=>{
    //   this.triggerBookingDelete = false;
    //   this.reloadBookingTasks();
    // });
  }
  //Amv09 end

  closeBooking() {
    this.isEnter = true;
    //Amv08
    this.triggerCloseBooking = true;
    //Amv08 end

    //Amv07
    if(this.podsignatory == "" || this.podsignatory == null){
      this.isEnter = false;

      //Amv08
      this.triggerCloseBooking = false;
      //Amv08 end

      return 0;
    }
    //Amv07 - end

    const payload = {
      Booking_ID:null,
      //Amv07
      podsignatory:null
    };

    payload.Booking_ID = this.selectedBooking.ID;
    //Amv07
    payload.podsignatory = this.podsignatory;

    //Amv08
    this.loadedBooking.payload = payload;
    //Amv08 end

    // this.http.post(this.ROUTE_ADMIN_CLOSE_BOOKING, payload).subscribe((response) => {
    //   this.reloadBookingTasks();
    // });

    //Amv08
    this.http.post(this.ROUTE_EDI_CLOSE, this.loadedBooking).subscribe((response)=>{
      let ediCloseResult = response;

      // console.log(ediCloseResult);

      if(ediCloseResult['edi'] == true){
        if(ediCloseResult['ediData'] == 200){
          //Successfully send out and accepted by NCC
          this.http.post(this.ROUTE_ADMIN_CLOSE_BOOKING, payload).subscribe((response) => {
            this.reloadBookingTasks();
            // this.triggerCloseBooking = false;
            // this.router.navigate(['/bookings']);
            this.getBookings();
          });

        }else{
          //Send out successfully but NCC drop it
          console.error(ediCloseResult);
          // this.triggerCloseBooking = false;
        }
      }else{
        this.http.post(this.ROUTE_ADMIN_CLOSE_BOOKING, payload).subscribe((response) => {
            // console.log("Non EDI");
            this.reloadBookingTasks();
            // this.triggerCloseBooking = false;
            // this.router.navigate(['/bookings']);
            this.getBookings();
        });
      }

    });
    //Amv08 end
  }

  //Amv08
  triggerPopup2(content1, isError, filedetail){
    let newdiv1 = document.getElementById("popContainer");
    let popDetail1 = document.createElement("div");
    let ranNumber = Math.floor(Math.random()* 20);
    popDetail1.setAttribute("id",filedetail.Original_File_Name + "_" + ranNumber);

    if(isError == true){
      popDetail1.innerHTML='<div class="alert alert-danger" role="alert"><strong class="alert-heading">'+ content1 +'</strong></div>';
    }else{
      popDetail1.innerHTML='<div class="alert alert-success" role="alert"><strong class="alert-heading">'+ content1 +'</strong></div>';
    }

    newdiv1?.appendChild(popDetail1);

    setTimeout(()=>{
      let elements = document.getElementById(filedetail.Original_File_Name + "_" + ranNumber);
      elements?.remove();
    }, 5000);

  }

  deleteBookingStep1() {
    this.deletingBooking = true;
  }

  cancelDelete() {
    this.deletingBooking = false;
  }

  deleteBookingStep2() {
    if(!this.deletingBooking) {
      return;
    }

    
  }

  getDO(){
    // console.log(this.selectedBooking);
    this.selectedBooking.GinTask = this.GIN_Task;

    // this.overlayManager.showGenerateDO(this.selectedBooking);

    const url = this.ROUTE_DO_GENERATE;

    //Create the name of the DO, It should be the same as tje generated PDF file
    this.http.post(this.ROUTE_DO_NAME, this.selectedBooking).subscribe((response)=>{
      let PDFname = response['Message'];

      // console.log(this.selectedBooking);
      //Download PDF file from service
      let DODownloadPromise = this.fileDownloadService.downloadDO(url, this.selectedBooking, PDFname);

    });

  }
  
  // Amv6
  deleteGIN(){
    console.log(this.selectedBooking);

    this.triggerBookingDelete = true;

    const url = this.ROUTE_ADMIN_DELETE_GIN1;

    this.http.post(this.ROUTE_ADMIN_DELETE_GIN1, this.selectedBooking).subscribe((response) =>{
      console.log(response);
      // this.router.navigate(['/bookings']);
      this.getBookings();
    });
  }
  // Amv6 -end

  // Amv12
  downloadGRTemplate(){
    let GRDetails = this.loadedBooking;
    console.log(GRDetails);

    this.http.post(this.ROUTE_EDI_GR_Template, GRDetails, { observe: 'response' }).subscribe(response => {
      let result = Object.values(response['body']) as any;
      console.log(result);

      if(result.length > 0){
        console.log("GR Template Enter");
        let workbook = new Workbook();

        workbook.creator = "My Cargo";
        workbook.created = new Date();
        workbook.modified = new Date();

        let worksheet = workbook.addWorksheet('GR Template', {views:[{state: 'frozen', ySplit: 1}]});

        worksheet.columns = [
          { header: 'SKU (PRODUCT CODE)', key: 'sku', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'PRODUCT DESCRIPTION', key: 'desc', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'QTY', key: 'qty', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'PER CTN', key: 'ctn', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'SERIAL NO.', key: 'sn', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'PART NO.', key: 'part', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'CURRENCY', key: 'currency', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'UNIT PRICE', key: 'unit', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'LENGTH (CM)', key: 'length', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'WIDTH (CM)', key: 'width', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'HEIGHT (CM)', key: 'height', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'WEIGHT (KG)', key: 'weight', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'BIN', key: 'bin', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}},
          { header: 'PERMIT NO.', key: 'permit', width: 19, style: {font: { name: 'Cambria', bold: true, size: 12 }}}
        ];

        worksheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.autoFilter = 'A1:N1';
        
        for (let i=0; i<result.length; i++){
          worksheet.addRow({
            sku: result[i].SKU,
            desc: result[i].Description,
            qty: result[i].Quantity,
            ctn: result[i].Denomination,
            sn: result[i].Expected_Serial_No,
            part: result[i].Part_No,
            currency: 'USD',
            unit: result[i].Dollar_Value,
            length: result[i].Length,
            width: result[i].Width,
            height: result[i].Height,
            weight: result[i].Weight,
            bin: result[i].Bin_Location,
            permit: result[i].Permit_No
          });
        }
        
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, 'TIC_EDI_GR_'+GRDetails['Customer_Ref_No1']+'.xlsx');
        })

      }

    });
  }
  // Amv12 end

  //Amv12
  GRHandleFileSelected(event){
    this.uploading = true;

    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;

    console.log(fileList);

    if(fileList){
      let file = fileList[0];

      const workbook = new Workbook();
      file.arrayBuffer().then(data => {
        workbook.xlsx.load(data).then(()=>{
          this.readGRItemsFromWorksheet(workbook.worksheets[0]);
        });
      });
    }
  }

  readGRItemsFromWorksheet(worksheet:Worksheet){
    this.fileItemsToLoad = 0;

    this.fileItemsToLoad = worksheet.actualRowCount;

    this.processGRItems = [];

    console.log(this.fileItemsToLoad);

    for(let i = 2; i <= worksheet.actualRowCount; i++){
      const row: Row = worksheet.getRow(i);

      const GRItems: EDIGRItems =  new EDIGRItems();

      GRItems.sku = row.getCell(1).value as any;
      GRItems.desc = row.getCell(2).value as any;
      GRItems.qty = row.getCell(3).value as any;
      GRItems.ctn = row.getCell(4).value as any;
      GRItems.sn = row.getCell(5).value as any;
      GRItems.part = row.getCell(6).value as any;
      GRItems.currency = row.getCell(7).value as any;
      GRItems.price = row.getCell(8).value as any;
      GRItems.length = row.getCell(9).value as any;
      GRItems.width = row.getCell(10).value as any;
      GRItems.height = row.getCell(11).value as any;
      GRItems.weight = row.getCell(12).value as any;
      GRItems.bin = row.getCell(13).value as any;
      GRItems.permit = row.getCell(14).value as any;

      this.processGRItems.push(GRItems);
    }

    //undefined, null & [] = false
    if(this.processGRItems?.length){
      console.log(this.processGRItems);
      this.isGRProcessed = true;
      this.isPassed = true;
      this.uploading = false;
    }
  }
  //Amv12 end

  //Amv12
  updateEDIGRItem(){
    this.uploading = true;
    this.isUpload = false;

    this.message ="";
    this.total_items = 0;
    this.updated_items = 0;
    this.not_found_items = 0;
    this.not_found_sn = [];
    this.failed_items = 0;
    this.errors = [];

    let GROrder = this.loadedBooking;
    GROrder['Processed_items'] = this.processGRItems;
    console.log(GROrder);

    this.http.post(this.ROUTE_EDI_GR_UPLOAD, GROrder, { observe: 'response' }).subscribe(response =>{
      const uploadResult = response['body'];
      console.log(uploadResult);
      console.log(uploadResult['status']);

      if(uploadResult['status']){
        this.isPassed = true;
        this.uploading = false;
        this.isUpload = true;

        this.message = uploadResult['message'];
        this.total_items = uploadResult['total_items'];
        this.updated_items = uploadResult['updated_items'];

      }else{
        this.isPassed = false;
        this.uploading = false;

        this.message = uploadResult['message'];
        this.total_items = uploadResult['total_items'];
        this.updated_items = uploadResult['updated_items'];
        this.not_found_items = uploadResult['not_found_items'];
        this.not_found_sn = uploadResult['not_found_sn'];
        this.failed_items = uploadResult['failed_items'];
        this.errors = uploadResult['errors'];
      }

    });
  }
  //Amv12 end

  get totalBookingItems(): number{
    return this.loadedBooking?.Items?.length || 0;
  }

  get totalBookingQty(): number{
    return this.loadedBooking?.Items?.reduce((sum, item)=>{
      return sum + (Number(item.Quantity) || 0);
    }, 0) || 0;
  }

  get totalBookingWeight(): number{
    const totalWeight = this.loadedBooking?.Items?.reduce((sum, item)=>{
      return sum + (item.Weight * item.Quantity);
    }, 0) || 0;

    return Number(totalWeight.toFixed(5));
  }

  get totalBookingDimension():number{
    const totalVolume = this.loadedBooking?.Items?.reduce((sum, item)=>{
      const volume = (item.Length * item.Width * item.Height) / 1000000;
      return sum + (volume * item.Quantity);
    }, 0) || 0;

    return Number(totalVolume.toFixed(5));
  }

}

//Amv12
class EDIGRItems{
  public sku: string;
  public desc: string;
  public qty: number;
  public ctn: number;
  public sn: string;
  public part: string;
  public currency: string;
  public price: number;
  public length: number;
  public width: number;
  public height: number;
  public weight: number;
  public bin: string;
  public permit: string;

  constructor(){
    this.qty = 1;
    this.ctn = 1;
  }
}
//Amv12 end
